import axios from "axios";
import { useQuery } from "react-query";

const getTenants = async () => {
    const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/admin/tenants`
    );
    return response?.data?.result;
};

export default function useTenants() {
    return useQuery("USE_TENANTS", () => getTenants());
}
